// extracted by mini-css-extract-plugin
module.exports = {"toolIcon":"ToolBox_toolIcon__1xGSn","toolButton":"ToolBox_toolButton__1g_hB","areaText":"ToolBox_areaText__2suFF"};